import React from 'react';
import { dataIt } from '../haccpApi';

export const STATI = {
  scaduto: { testo: 'Scaduto', stile: 'bg-red-600 text-white' },
  mancante: { testo: 'Manca', stile: 'bg-red-100 text-red-700' },
  in_scadenza: { testo: 'In scadenza', stile: 'bg-amber-100 text-amber-800' },
  da_valutare: { testo: 'Da valutare', stile: 'bg-slate-100 text-slate-700' },
  consigliato: { testo: 'Consigliato', stile: 'bg-sky-100 text-sky-700' },
  valido: { testo: 'Valido', stile: 'bg-emerald-100 text-emerald-700' },
  non_applicabile: { testo: 'Non mi riguarda', stile: 'bg-gray-100 text-gray-500' },
};

export const BadgeStato = ({ stato, testid }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold whitespace-nowrap ${STATI[stato]?.stile || ''}`} data-testid={testid}>
    {STATI[stato]?.testo || stato}
  </span>
);

export const quando = (doc, giorni) => {
  if (!doc) return '';
  if (!doc.scadenza) return 'senza scadenza';
  if (giorni < 0) return `scaduto il ${dataIt(doc.scadenza)}`;
  if (giorni === 0) return 'scade oggi';
  return `scade il ${dataIt(doc.scadenza)}${giorni <= 60 ? ` (tra ${giorni} giorni)` : ''}`;
};
